import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PurchaseHistoryList from './PurchaseHistoryList';

/**
 * Standalone purchase-history dialog for the till and lähete views — the
 * seller answers "olen ostanut teiltä tällaisen..." without leaving the sale.
 */
function CustomerPurchaseHistoryDialog({ open, onClose, customerId, customerName }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
      <DialogTitle>
        {t('Purchase history')}
        {customerName ? ` — ${customerName}` : ''}
      </DialogTitle>
      <DialogContent>
        {open && customerId && (
          <PurchaseHistoryList customerId={customerId} onInvoiceClick={(id) => navigate(`/invoices/${id}`)} />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="secondary" data-testid="purchase-history-close">
          {t('Close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CustomerPurchaseHistoryDialog;
